export const messages = {
  en: {
    repairDispatchManage: {
      searchConditions: 'Search Conditions',
      repairBacklog: 'Repair Backlog',
      all: 'All',
      placeholder: {
        repairId: 'Please enter work order number',
        repairName: 'Please enter reporter name',
        tel: 'Please enter reporter phone',
        selectRepairType: 'Please select repair type',
        selectStatus: 'Please select status'
      },
      table: {
        location: 'Location',
        repairType: 'Repair Type',
        repairPerson: 'Reporter',
        repairPhone: 'Reporter Phone',
        appointmentTime: 'Appointment Time',
        status: 'Status',
        operation: 'Operation'
      },
      transferOrder: 'Transfer Order',
      returnOrder: 'Return Order',
      complete: 'Complete',
      returnVisit: 'Return Visit',
      pause: 'Pause',
      start: 'Start',
      detail: 'Detail',
      scheduledTask: 'Scheduled Task',
      dispatchRepair: 'Dispatch Repair',
      previousHandler: 'Previous Handler',
      requiredPreviousHandler: 'Required, please fill in the previous handler',
      repairMaster: 'Repair Master',
      requiredRepairMaster: 'Required, please select repair master',
      handlingOpinions: 'Handling Opinions',
      requiredHandlingOpinions: 'Required, please fill in handling opinions',
      returnVisitSuggestion: 'Return Visit Suggestion',
      requiredReturnVisitSuggestion: 'Required, please fill in return visit suggestion',
      pauseReason: 'Pause Reason',
      requiredPauseReason: 'Required, please fill in pause reason',
      confirmOperation: 'Confirm Operation',
      confirmStartRepair: 'Confirm to start the repair?',
      cannotTransferToSelf: 'Cannot transfer the order to yourself',
      fetchRepairListFailed: 'Failed to get repair list',
      fetchRepairTypesFailed: 'Failed to get repair types',
      fetchRepairMasterFailed: 'Failed to get repair masters',
      dispatchFailed: 'Dispatch failed',
      returnVisitFailed: 'Return visit failed',
      pauseFailed: 'Pause failed',
      startFailed: 'Start failed'
    }
  },
  zh: {
    repairDispatchManage: {
      searchConditions: '查询条件',
      repairBacklog: '报修待办',
      all: '全部',
      placeholder: {
        repairId: '请输入工单编号',
        repairName: '请输入报修人',
        tel: '请输入报修人电话',
        selectRepairType: '请选择报修类型',
        selectStatus: '请选择报修状态'
      },
      table: {
        location: '位置',
        repairType: '报修类型',
        repairPerson: '报修人',
        repairPhone: '报修人电话',
        appointmentTime: '预约时间',
        status: '状态',
        operation: '操作'
      },
      transferOrder: '转单',
      returnOrder: '退单',
      complete: '办结',
      returnVisit: '回访',
      pause: '暂停',
      start: '启动',
      detail: '详情',
      scheduledTask: '定时任务处理',
      dispatchRepair: '报修派单',
      previousHandler: '上级处理人',
      requiredPreviousHandler: '必填，请填写上级处理人',
      repairMaster: '报修师傅',
      requiredRepairMaster: '必填，请选择报修师傅',
      handlingOpinions: '处理意见',
      requiredHandlingOpinions: '必填，请填写处理意见',
      returnVisitSuggestion: '回访建议',
      requiredReturnVisitSuggestion: '必填，请填写回访建议',
      pauseReason: '暂停原因',
      requiredPauseReason: '必填，请填写暂停原因',
      confirmOperation: '确认操作',
      confirmStartRepair: '确定启动报修？',
      cannotTransferToSelf: '不能转单给自己',
      fetchRepairListFailed: '获取报修列表失败',
      fetchRepairTypesFailed: '获取报修类型失败',
      fetchRepairMasterFailed: '获取维修师傅列表失败',
      dispatchFailed: '派单失败',
      returnVisitFailed: '回访失败',
      pauseFailed: '暂停失败',
startFailed: '启动失败'
    }
  },
  'zh-TW': {
    repairDispatchManage: {
      searchConditions: '查詢條件',
      repairBacklog: '報修待辦',
      all: '全部',
      placeholder: {
        repairId: '請輸入工單編號',
        repairName: '請輸入報修人',
        tel: '請輸入報修人電話',
        selectRepairType: '請選擇報修類型',
        selectStatus: '請選擇報修狀態'
      },
      table: {
        location: '位置',
        repairType: '報修類型',
        repairPerson: '報修人',
        repairPhone: '報修人電話',
        appointmentTime: '預約時間',
        status: '狀態',
        operation: '操作'
      },
      transferOrder: '轉單',
      returnOrder: '退單',
      complete: '辦結',
      returnVisit: '回訪',
      pause: '暫停',
      start: '啟動',
      detail: '詳情',
      scheduledTask: '定時任務處理',
      dispatchRepair: '報修派單',
      previousHandler: '上級處理人',
      requiredPreviousHandler: '必填，請填寫上級處理人',
      repairMaster: '報修師傅',
      requiredRepairMaster: '必填，請選擇報修師傅',
      handlingOpinions: '處理意見',
      requiredHandlingOpinions: '必填，請填寫處理意見',
      returnVisitSuggestion: '回訪建議',
      requiredReturnVisitSuggestion: '必填，請填寫回訪建議',
      pauseReason: '暫停原因',
      requiredPauseReason: '必填，請填寫暫停原因',
      confirmOperation: '確認操作',
      confirmStartRepair: '確定啟動報修？',
      cannotTransferToSelf: '不能轉單給自己',
      fetchRepairListFailed: '獲取報修列表失敗',
      fetchRepairTypesFailed: '獲取報修類型失敗',
      fetchRepairMasterFailed: '獲取維修師傅列表失敗',
      dispatchFailed: '派單失敗',
      returnVisitFailed: '回訪失敗',
      pauseFailed: '暫停失敗',
      startFailed: '啟動失敗'
    }
  }
}